import Vue from 'vue'
import Router from 'vue-router'
import store from '../stores'
import ContentAuth from '@/pages/auth/Content'
import Login from '@/pages/auth/Login'
import Register from '@/pages/auth/Register'
import Thanks from '@/pages/auth/Thanks'
import ForgetPassword from '@/pages/auth/ForgetPassword'
import PasswordReset from '@/pages/auth/PasswordReset'
import CompleteAccount from '@/pages/auth/CompleteAccount'

//administrador
import Content from '@/layout/Content'
import Dashboard from '@/pages/Dashboard'
import Profile from '@/pages/profile/Index'

//Packages
import UserIndex from '@/pages/users/Index'
import UserCreate from '@/pages/users/Create'
import UserDetail from '@/pages/users/Detail'
import UserUpdate from '@/pages/users/Update'

//Packages
import PackageIndex from '@/pages/packages/Index'
import PackageCreate from '@/pages/packages/Create'
import PackageMe from '@/pages/packages/client/PackageMe'
import PackageDetailPrealert from '@/pages/packages/client/DetailPrealert'
import PackageUpdatePrealert from '@/pages/packages/client/UpdatePrealert'
import PackageCreatePrealert from '@/pages/packages/client/CreatePrealert'
import PackageCreateMiami from '@/pages/packages/CreateMiami'
import PackageUpdate from '@/pages/packages/Update'
import PackageDetail from '@/pages/packages/Detail'
import PackageFel from '@/pages/packages/Fel'
import PackageInvoice from '@/pages/packages/Invoice'
import Billing from '@/pages/packages/Billing'
import Warehouse from '@/pages/packages/Warehouse'
import Validations from '@/pages/packages/Validations'
import Validated from '@/pages/packages/Validated'
import Exemptions from '@/pages/packages/Exemptions'
import AccountPayments from '@/pages/packages/account-payments/AccountPayments'

//Awb
import AwbIndex from '@/pages/awbs/Index'
import AwbDetail from '@/pages/awbs/Detail'
import AwbScan from '@/pages/awbs/Scan'

//Routes
import DeliverRouteIndex from '@/pages/delivery-routes/Index'
import DeliverRouteCreate from '@/pages/delivery-routes/Create'
import DeliverRouteUpdate from '@/pages/delivery-routes/Update'
import DeliverRoutePackages from '@/pages/delivery-routes/Packages'
import DeliverRouteClosing from '@/pages/delivery-routes/Closing'
import DeliverRouteClosingDetail from '@/pages/delivery-routes/ClosingDetail'
import DeliverRouteScan from '@/pages/delivery-routes/Scan'

//Permission or Permission
import PermissionIndex from '@/pages/settings/permissions/Index'
import PermissionUpdate from '@/pages/settings/permissions/Update'
import PermissionItemCreate from "@/pages/settings/permissions/items/Create";
import PermissionItemUpdate from '@/pages/settings/permissions/items/Update'

//Roles
import RoleIndex from '@/pages/settings/roles/Index'
import RoleUpdate from '@/pages/settings/roles/Update'

//States
import StateIndex from '@/pages/settings/states/Index'
import StateUpdate from '@/pages/settings/states/Update'
import StateCreate from '@/pages/settings/states/Create'

//States
import PaymentStateIndex from '@/pages/settings/payment_states/Index'
import PaymentStateUpdate from '@/pages/settings/payment_states/Update'
import PaymentStateCreate from '@/pages/settings/payment_states/Create'

//Taxes
import TaxIndex from '@/pages/settings/taxes/Index'
import TaxCreate from '@/pages/settings/taxes/Create'
import TaxUpdate from '@/pages/settings/taxes/Update'

//Taxes
import TopTaxIndex from '@/pages/settings/top_taxes/Index'
import TopTaxCreate from '@/pages/settings/top_taxes/Create'
import TopTaxUpdate from '@/pages/settings/top_taxes/Update'

//Carriers
import CarrierIndex from '@/pages/settings/carriers/Index'
import CarrierCreate from '@/pages/settings/carriers/Create'
import CarrierUpdate from '@/pages/settings/carriers/Update'

//Units
import UnitIndex from '@/pages/settings/units/Index'
import UnitCreate from '@/pages/settings/units/Create'
import UnitUpdate from '@/pages/settings/units/Update'

//Packings
import PackingIndex from '@/pages/settings/packings/Index'
import PackingCreate from '@/pages/settings/packings/Create'
import PackingUpdate from '@/pages/settings/packings/Update'

//Reasons
import ReasonIndex from '@/pages/settings/reasons/Index'
import ReasonCreate from '@/pages/settings/reasons/Create'
import ReasonUpdate from '@/pages/settings/reasons/Update'

//Sources
import SourceIndex from '@/pages/settings/sources/Index'
import SourceCreate from '@/pages/settings/sources/Create'
import SourceUpdate from '@/pages/settings/sources/Update'

//Branch Offices
import BranchOfficeIndex from '@/pages/settings/branch_offices/Index'
import BranchOfficeCreate from '@/pages/settings/branch_offices/Create'
import BranchOfficeUpdate from '@/pages/settings/branch_offices/Update'

//Routes
import RouteIndex from '@/pages/settings/routes/Index'
import RouteCreate from '@/pages/settings/routes/Create'
import RouteUpdate from '@/pages/settings/routes/Update'

//Calculator
import Calculator from '@/pages/settings/calculator/Index'
import Config from '@/pages/settings/config/Index'

import History from '@/pages/history/Index'
import Reports from '@/pages/reports/Index'
//REPORTS
import ReportPackageByWeight from '@/pages/reports/views/PackageByWeight'
import ReportSalesTax from '@/pages/reports/views/SalesTax'
import ReportAwb from '@/pages/reports/views/Awb'
import ReportInvoice from '@/pages/reports/views/Invoice'
import ReportAffiliations from '@/pages/reports/views/Affiliations'
import ReportRejected from '@/pages/reports/views/Rejected'
import ReportWerehouse from '@/pages/reports/views/Werehouse'

import ReportBillingGrowth from '@/pages/reports/views/BillingGrowth'
import ReportRecovery from '@/pages/reports/views/Recovery'

import P401 from '@/pages/P401'
import P403 from '@/pages/P403'
import P404 from '@/pages/P404'

Vue.use(Router)
const routesWithPrefix = (prefix, routes) => {
  return routes.map(route => {
    route.path = `${prefix}${route.path}`
    return route
  })
}
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: ContentAuth,
      meta: { requiresAuth: false },
      children: [
        {
          path: '/',
          name: 'Login',
          component: Login,
        },
        {
          path: '/register',
          name: 'Register',
          component: Register,
        },
        {
          path: '/thanks/:slug',
          name: 'Thanks',
          component: Thanks,
        },
        {
          path: '/complete/account',
          name: 'CompleteAccount',
          component: CompleteAccount,
        },
        {
          path: '/forget/password',
          name: 'ForgetPassword',
          component: ForgetPassword,
        },
        {
          path: '/password/reset',
          name: 'PasswordReset',
          component: PasswordReset,
        }
      ]
    },
    {
      path: '/',
      component: Content,
      meta: { requiresAuth: true },
      children: [
        ...routesWithPrefix('/admin/panel', [
          {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
          },
          {
            path: '/profile',
            name: 'Profile',
            component: Profile,
          },
          ...routesWithPrefix('/users', [
            {
              path: '/managers',
              name: 'ManagersIndex',
              component: UserIndex,
              meta: { role: 'managers' }
            },
            {
              path: '/employees',
              name: 'EmployeesIndex',
              component: UserIndex,
              meta: { role: 'employees' }
            },
            {
              path: '/drivers',
              name: 'DriversIndex',
              component: UserIndex,
              meta: { role: 'drivers' }
            },
            {
              path: '/warehouses',
              name: 'WarehousesIndex',
              component: UserIndex,
              meta: { role: 'warehouses' }
            },
            {
              path: '/customers',
              name: 'CustomersIndex',
              component: UserIndex,
              meta: { role: 'customers' }
            },
            {
              path: '/warehouse_arrivals',
              name: 'WarehouseArrivalsIndex',
              component: UserIndex,
              meta: { role: 'warehouse_arrivals' }
            },
            {
              path: '/costumer_service',
              name: 'CostumerServiceIndex',
              component: UserIndex,
              meta: { role: 'costumer_service' }
            },
            {
              path: '/accounting',
              name: 'AccountingIndex',
              component: UserIndex,
              meta: { role: 'accounting' }
            },
            {
              path: '/:role/create',
              name: 'UserCreate',
              component: UserCreate,
            },
            {
              path: '/:role/detail/:id',
              name: 'UserDetail',
              component: UserDetail,
            },
            {
              path: '/:role/update/:id',
              name: 'UserUpdate',
              component: UserUpdate,
            }
          ]),
          ...routesWithPrefix('/packages', [
            {
              path: '/',
              name: 'PackageIndex',
              component: PackageIndex,
            },
            {
              path: '/create',
              name: 'PackageCreate',
              component: PackageCreate,
            },
            {
              path: '/:id/edit',
              name: 'PackageUpdate',
              component: PackageUpdate,
            },
            {
              path: '/:id/detail',
              name: 'PackageDetail',
              component: PackageDetail,
            },
            {
              path: '/:id/fel',
              name: 'PackageFel',
              component: PackageFel,
            },
            {
              path: '/prealerts',
              name: 'PackageMe',
              component: PackageMe,
            },
            {
              path: '/prealerts/:id/detail',
              name: 'PackageDetailPrealert',
              component: PackageDetailPrealert,
            },
            {
              path: '/prealerts/:id/edit',
              name: 'PackageUpdatePrealert',
              component: PackageUpdatePrealert,
            },
            {
              path: '/create/prealert',
              name: 'PackageCreatePrealert',
              component: PackageCreatePrealert,
            },
            {
              path: '/create/miami/:id?',
              name: 'PackageCreateMiami',
              component: PackageCreateMiami,
            },
            {
              path: '/:id/invoice',
              name: 'PackageInvoice',
              component: PackageInvoice,
            },
            {
              path: '/billing',
              name: 'Billing',
              component: Billing,
            },
            {
              path: '/warehouse',
              name: 'Warehouse',
              component: Warehouse,
            },
            {
              path: '/exemptions',
              name: 'Exemptions',
              component: Exemptions,
            },
            {
              path: '/validations',
              name: 'Validations',
              component: Validations,
            },
            {
              path: '/validated',
              name: 'Validated',
              component: Validated,
            },
            {
              path: '/account/payments',
              name: 'AccountPayments',
              component: AccountPayments,
            },
          ]),
          ...routesWithPrefix('/awbs', [
            {
              path: '/',
              name: 'AwbIndex',
              component: AwbIndex,
            },
            {
              path: '/:awb/detail',
              name: 'AwbDetail',
              component: AwbDetail,
            },
            {
              path: '/scan',
              name: 'AwbScan',
              component: AwbScan,
            },
          ]),
          ...routesWithPrefix('/deliver-routes', [
            {
              path: '/',
              name: 'DeliverRouteIndex',
              component: DeliverRouteIndex,
            },
            {
              path: '/create',
              name: 'DeliverRouteCreate',
              component: DeliverRouteCreate,
            },
            {
              path: '/:id/update',
              name: 'DeliverRouteUpdate',
              component: DeliverRouteUpdate,
            },
            {
              path: '/:id/packages',
              name: 'DeliverRoutePackages',
              component: DeliverRoutePackages,
            },
            {
              path: '/closing',
              name: 'DeliverRouteClosing',
              component: DeliverRouteClosing,
            },
            {
              path: '/closing/:id',
              name: 'DeliverRouteClosingDetail',
              component: DeliverRouteClosingDetail,
            },
            {
              path: '/scan',
              name: 'DeliverRouteScan',
              component: DeliverRouteScan,
            },
          ]),
          ...routesWithPrefix('/settings', [
            ...routesWithPrefix('/permissions', [
              {
                path: '/',
                name: 'PermissionIndex',
                component: PermissionIndex,
              },
              {
                path: '/update/:id',
                name: 'PermissionUpdate',
                component: PermissionUpdate,
              },
              {
                path: "/item/create/:id",
                name: "PermissionItemCreate",
                component: PermissionItemCreate,
              },
              {
                path: '/item/update/:id',
                name: 'PermissionItemUpdate',
                component: PermissionItemUpdate,
              }
            ]),
            ...routesWithPrefix('/roles', [
              {
                path: '/',
                name: 'RoleIndex',
                component: RoleIndex,
              },
              {
                path: '/update/:id',
                name: 'RoleUpdate',
                component: RoleUpdate,
              }
            ]),
            ...routesWithPrefix('/states', [
              {
                path: '/',
                name: 'StateIndex',
                component: StateIndex,
              },
              {
                path: '/create',
                name: 'StateCreate',
                component: StateCreate,
              },
              {
                path: '/update/:id',
                name: 'StateUpdate',
                component: StateUpdate,
              }
            ]),
            ...routesWithPrefix('/payment/states', [
              {
                path: '/',
                name: 'PaymentStateIndex',
                component: PaymentStateIndex,
              },
              {
                path: '/create',
                name: 'PaymentStateCreate',
                component: PaymentStateCreate,
              },
              {
                path: '/update/:id',
                name: 'PaymentStateUpdate',
                component: PaymentStateUpdate,
              }
            ]),
            ...routesWithPrefix('/taxes', [
              {
                path: '/',
                name: 'TaxIndex',
                component: TaxIndex,
              },
              {
                path: '/create',
                name: 'TaxCreate',
                component: TaxCreate,
              },
              {
                path: '/update/:id',
                name: 'TaxUpdate',
                component: TaxUpdate,
              }
            ]),
            ...routesWithPrefix('/top/taxes', [
              {
                path: '/',
                name: 'TopTaxIndex',
                component: TopTaxIndex,
              },
              {
                path: '/create',
                name: 'TopTaxCreate',
                component: TopTaxCreate,
              },
              {
                path: '/update/:id',
                name: 'TopTaxUpdate',
                component: TopTaxUpdate,
              }
            ]),
            ...routesWithPrefix('/carriers', [
              {
                path: '/',
                name: 'CarrierIndex',
                component: CarrierIndex,
              },
              {
                path: '/create',
                name: 'CarrierCreate',
                component: CarrierCreate,
              },
              {
                path: '/update/:id',
                name: 'CarrierUpdate',
                component: CarrierUpdate,
              }
            ]),
            ...routesWithPrefix('/units', [
              {
                path: '/',
                name: 'UnitIndex',
                component: UnitIndex,
              },
              {
                path: '/create',
                name: 'UnitCreate',
                component: UnitCreate,
              },
              {
                path: '/update/:id',
                name: 'UnitUpdate',
                component: UnitUpdate,
              }
            ]),
            ...routesWithPrefix('/packings', [
              {
                path: '/',
                name: 'PackingIndex',
                component: PackingIndex,
              },
              {
                path: '/create',
                name: 'PackingCreate',
                component: PackingCreate,
              },
              {
                path: '/update/:id',
                name: 'PackingUpdate',
                component: PackingUpdate,
              }
            ]),
            ...routesWithPrefix('/reasons', [
              {
                path: '/',
                name: 'ReasonIndex',
                component: ReasonIndex,
              },
              {
                path: '/create',
                name: 'ReasonCreate',
                component: ReasonCreate,
              },
              {
                path: '/update/:id',
                name: 'ReasonUpdate',
                component: ReasonUpdate,
              }
            ]),
            ...routesWithPrefix('/sources', [
              {
                path: '/',
                name: 'SourceIndex',
                component: SourceIndex,
              },
              {
                path: '/create',
                name: 'SourceCreate',
                component: SourceCreate,
              },
              {
                path: '/update/:id',
                name: 'SourceUpdate',
                component: SourceUpdate,
              }
            ]),
            ...routesWithPrefix('/routes', [
              {
                path: '/',
                name: 'RouteIndex',
                component: RouteIndex,
              },
              {
                path: '/create',
                name: 'RouteCreate',
                component: RouteCreate,
              },
              {
                path: '/update/:id',
                name: 'RouteUpdate',
                component: RouteUpdate,
              }
            ]),
            ...routesWithPrefix('/branch-offices', [
              {
                path: '/',
                name: 'BranchOfficeIndex',
                component: BranchOfficeIndex,
              },
              {
                path: '/create',
                name: 'BranchOfficeCreate',
                component: BranchOfficeCreate,
              },
              {
                path: '/update/:id',
                name: 'BranchOfficeUpdate',
                component: BranchOfficeUpdate,
              }
            ]),
            {
              path: '/calculator',
              name: 'Calculator',
              component: Calculator,
            },
            {
              path: '/config',
              name: 'Config',
              component: Config,
            },
          ]),
          ...routesWithPrefix('/reports', [
            {
              path: '/',
              name: 'Reports',
              component: Reports,
            },
            {
              path: '/awb',
              name: 'ReportAwb',
              component: ReportAwb,
              props: true,
            },
            {
              path: '/werehouse',
              name: 'ReportWerehouse',
              component: ReportWerehouse,
              props: true,
            },
            {
              path: '/rejected',
              name: 'ReportRejected',
              component: ReportRejected,
              props: true,
            },
            {
              path: '/affiliations',
              name: 'ReportAffiliations',
              component: ReportAffiliations,
              props: true,
            },
            {
              path: '/package-by-weight',
              name: 'ReportPackageByWeight',
              component: ReportPackageByWeight,
              props: true,
            },  
            {
              path: '/sales-tax',
              name: 'ReportSalesTax',
              component: ReportSalesTax,
              props: true,
            },
            {
              path: '/invoice',
              name: 'ReportInvoice',
              component: ReportInvoice,
              props: true,
            },
            {
              path: '/billing-growth',
              name: 'ReportBillingGrowth',
              component: ReportBillingGrowth,
              props: true,
            },
            {
              path: '/recovery',
              name: 'ReportRecovery',
              component: ReportRecovery,
              props: true,
            },
          ]),
          {
            path: '/history',
            name: 'History',
            component: History,
          },
          {
            path: '/forbidden',
            name: 'P403',
            component: P403
          }
        ])
      ]
    },
    {
      path: '/page-404',
      name: 'P404',
      component: P404
    },
    {
      path: '/unautorized',
      name: 'P401',
      component: P401
    },
    {
      path: '*',
      redirect: { name: 'P404' }
    }
  ],
  linkExactActiveClass: 'active'
})

router.beforeEach(async (to, from, next) => {
  let access_token = store.getters['access_token']
  let user = store.getters['user']
  let permissions = store.getters['permissions']
  const publicPages = ['P401', 'P403', 'P404', 'Profile']
  const ignores = publicPages.includes(to.name)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (access_token && user) {
      if (ignores || permissions.length === 0 || !Array.isArray(permissions)) {
        if(to.name != 'P403'){
          if(to.name == 'Profile'){
            next()
          }else{
            next({ name: 'P403' })
          }
        }else{
          next()
        }
      }else{
        if(permissions.findIndex((e) => { return e.route == to.name || (!Array.isArray(e.items) ? -1 : e.items.findIndex((i) => { return i.route == to.name }) !== -1) }) !== -1){
          next()
        }else{
          if(permissions.findIndex((e) => { return e.route == to.name || (!Array.isArray(e.items) ? -1 : e.items.findIndex((i) => { return i.route == to.name }) !== -1) }) === -1){
            next({ name: 'P403' })
          }else{
            if(permissions[0]){
              if(permissions[0].items.length > 0){
                next({ name: permissions[0].items[0].route })
              }else{
                next({ name: permissions[0].route })
              }
            }else{
              next({ name: 'P403' })
            }
          }
        }
      }
    } else {
      next({ name: 'Login' })
    }
  } else {
    if (access_token && user) {
      if(ignores){
        next()
      }else{
        if(permissions[0]){
          if(permissions[0].items.length > 0){
            next({ name: permissions[0].items[0].route })
          }else{
            next({ name: permissions[0].route })
          }
        }else{
          next({ name: 'P403' })
        }
      }
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js